import { cn } from '@tripleten/cn';

export const cnForm = cn('kc-form');
